import { Directive, ElementRef, HostBinding, input, OnInit, inject } from '@angular/core'
import { ImageService } from 'src/app/core/services/image.service'
import { defaultLegacyImageProcessorOptions, ILegacyImageProcessorOptions } from '../interfaces/image.interface'
import { ImageSizes } from '../interfaces/media-library.interface'
import { GlobalDataService } from '../services/global-data.service'

@Directive({
  selector: '[imageSource]',
})
export class ImageSourceDirective implements OnInit {
  eleRef = inject(ElementRef)
  private imageService = inject(ImageService)
  private globalDataService = inject(GlobalDataService)

  imageSource = input<ILegacyImageProcessorOptions>(defaultLegacyImageProcessorOptions)
  applyWatermark = input(false)

  @HostBinding('src') src!: string

  ngOnInit(): void {
    this.setSrc()
  }

  setSrc(): void {
    const {
      guid,
    } = this.imageSource()
    this.src = this.imageService.buildImageSrc(guid, this.imageSource())
    const logo = this.globalDataService.config().header?.data?.logo?.src_data?.urls?.[ImageSizes.Thumbnail]
    if (logo && this.globalDataService.config().general?.data?.watermark_logo && this.applyWatermark()) {
      // Apply watermark if logo is provided and watermarking is enabled
      this.imageService.applyWatermark(this.src, logo).then(dataUrl => {
        this.src = dataUrl
      })
    }
  }
}
